<!-- Atlan WIP  -->
<!-- This component has been adjusted to render astral fields and may need further adjustments to work in other parts of the application -->

@if (title) {
  <h4 class="address__title astral-heading-with-help">
    <!-- <span class="d-inline-block"> -->
    <!-- @if (helpText) { <app-help-text [dataContext]="helpText"></app-help-text> } -->
    <span>{{ title | translate }}</span>
    @if (resolvedHelpText) {
      <astral-popover [helpText]="resolvedHelpText" />
    }
  <!-- </span> -->
</h4>
}

@if (group) {
  <astral-layout-group class="address-form" [columns]="4" [mobileColumns]="2" [columnGap]="'16px'">
    <astral-input class="address-form__street" [control]="street"></astral-input>
    <astral-input [control]="postalCode"></astral-input>
    <astral-input class="address-form__city" [style.--address-form-city-columns]="resolvedCityColumnSpan" [control]="city"></astral-input>
    <div class="address-form__country" [style.--address-form-country-columns]="resolvedCountryColumnSpan">
      <app-autocomplete-remote [control]="country" [service]="countryService" [defaultSearch]="'*'" #countyinput></app-autocomplete-remote>
    </div>
  </astral-layout-group>
}
